import React from 'react';
import {Text, View} from 'react-native';
import moment from 'moment';

import Locale from './../../Locale';
import {Layout, Navbar} from './../../Screen';
import {Form, Heading1, DropDownList,
  Divider, Button, TextInput} from './../../Form';
import DHScreen from './DHScreen';
import LegalStatement from './../components/LegalStatement';
import MobileNumberOfTheInsuranceAdvisor
  from './../components/MobileNumberOfTheInsuranceAdvisor';
import EffectiveDate from './../components/EffectiveDate';
import DiscountInput from './../components/DiscountInput';
import PolicyHolderForm from './../components/PolicyHolderForm';
import DomesticHelperForm from './DomesticHelperForm';
import DomesticHelperYesNoForm from './DomesticHelperYesNoForm';
import SpecialRequest from './../components/SpecialRequest';
import ReferralCode from './../components/ReferralCode';

export default class DHScreen3 extends DHScreen {
  render() {
    const {pl, agent, policy, policyHolder,
      domesticHelper, payment} = this.state.insuranceProduct;

    return (
      <Layout alert={this.state.alert}>
        <Navbar
          screen={this}
          title={Locale.text.getInsured}
        />

        {Locale.text.domesticHelperInsurance}
        {Locale.text.domesticHelperInsuranceLeftPanel}

        <View style={Layout.container}>
          <Form>
            <Heading1>
              {Locale.text.domesticHelperInsurance}
            </Heading1>

            <LegalStatement
              broker={this.state.broker}
              agent={this.state.agent}
            />

            <Text>
              {Locale.text.pleaseInputInEnglish}
            </Text>

            <MobileNumberOfTheInsuranceAdvisor
              broker={this.state.broker}
              value={agent.mobile}
              onChange={(mobile) => this.updateAgent({mobile})}
              messages={this.state.messages.agent}
            />

            <DropDownList
              label={Locale.text.productType}
              options={this.includeOutpatientOptions}
              value={domesticHelper.includeOutpatient}
              onChange={(includeOutpatient) =>
                this.updateDomesticHelper({includeOutpatient})}
            />

            <DropDownList
              label={Locale.text.periodOfInsurance}
              options={this.DHPlanType}
              value={pl}
              onChange={(pl) => {
                this.updatePlanCode(pl)
                this.updatePolicy({effectiveDateStart: null});
              }}
            />

              <EffectiveDate
              value={policy.effectiveDateStart}
              plan={this.state.insuranceProduct.pl}
              onChange={(effectiveDate) => this.updatePolicy(effectiveDate)}
              messages={this.state.messages.policy}
            />

            <DiscountInput
              promotionCode={payment.promotionCode}
              businessEmail={policy.businessEmail}
              directCustomer={!this.state.agent && !this.state.broker}
              onChange={({promotionCode, businessEmail}) => {
                this.updatePayment({promotionCode});
                this.updatePolicy({businessEmail});
              }}
              messages={this.state.messages.discount}
            />

            <Divider />

            <PolicyHolderForm
              noDocument
              noDateOfBirth
              addressLabel={Locale.text.residentialAddress}
              addressMandatory
              policyHolder={policyHolder}
              onChange={(data) => this.updatePolicyHolder(data)}
              messages={this.state.messages.policyHolder}
            />

            <Divider />

            <DomesticHelperForm
              domesticHelper={domesticHelper}
              onChange={(data) => this.updateDomesticHelper(data)}
              messages={this.state.messages.domesticHelper}
            />

            <TextInput
              label={Locale.text.workingLocationInHK}
              value={policyHolder.address1}
              onChange={(address1) => this.updatePolicyHolder({address1})}
              disabled
              multiline
            />

            <DomesticHelperYesNoForm
              domesticHelper={domesticHelper}
              onChange={(data) => this.updateDomesticHelper(data)}
              messages={this.state.messages.domesticHelper}
            />

            <Divider />

            <SpecialRequest
              value={policy.specialRequest}
              onChange={(specialRequest) =>
                this.updatePolicy({specialRequest})}
              messages={this.state.messages.policy}
            />

            <ReferralCode
            value={policy.referralCode}
              onChange={(referralCode) =>
                this.updatePolicy({referralCode})}
              messages={this.state.messages.referralCode}>
            </ReferralCode>

            <Button
              disabled={this.state.waiting}
              onPress={() => this.getQuote('domestic4')}
            >
              {Locale.text.buyNow}
            </Button>
          </Form>
        </View>
      </Layout>
    );
  }
}
